import React from 'react';
import PropTypes from 'prop-types';

import useReportSubscriptionService from '../../../modules/hooks/reportsubscriptions/hook';

import LoadingDialog from '../../../components/loadingdialog/components/loadingdialog';

const createReportItem = (reportSub, action) => {
    return (
        <div style={{marginBottom: '10px'}}>
            <div style={{minWidth:'500px', display: 'inline-block'}}>
            <strong>{reportSub.reportName}</strong>
            </div>
            <div style={{minWidth:'500px', display: 'inline-block'}}>
                {reportSub.description}
            </div>
            <div style={{minWidth:'100px', display: 'inline-block'}}>
                <button
                    onClick={e => { 
                        e.preventDefault(); 
                        e.currentTarget.disabled = true;
                        action(reportSub.subscriptionId); 
                        alert('Report request has been submitted');
                    }}
                >
                    Run Report
                </button>
            </div>        
        </div>
    );
};

const createReportListHeader = () => {
    return (
        <div style={{marginBottom: '10px'}}>
            <div style={{minWidth:'500px', fontSize:'20px', display: 'inline-block'}}>
            <strong>Report Name</strong>
            </div>
            <div style={{minWidth:'500px', fontSize:'20px', display: 'inline-block'}}>
                <strong>Subscription Name</strong>
            </div>
            <div style={{minWidth:'100px', display: 'inline-block'}}>
            </div>        
        </div>
    );
};

const ReportSubscriptions = props => {
    const [state, boundActions] = useReportSubscriptionService(props.service);
    return (<div style={{ overflowY: 'auto', height:'95%' }}>
        {/* title */}
        <div>
          <h1>Scheduled Report Subscriptions</h1>
          <h3>All request may take 5 to 10 minutes to initiate after submittal.</h3>
          <div>
            {createReportListHeader()}
            {state.reportSubscriptions.map(reportSub => createReportItem(reportSub, boundActions.runReportSubscription))}
          </div>
        </div>
        </div>);
};

export default ReportSubscriptions;